import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardHeader, Col, Label, Row } from "reactstrap";
import { useContext } from "react";
import KYBCompanyContext from "../../../../contexts/KYBCompanyContext";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { RiPencilLine } from "react-icons/ri";

const ConfirmSearchItem = ({
    t,
    onNextButtonClicked,
    onCancelButtonClicked
}) => {
    const {
        supplierData,
        companyData,
        setCompanyData
    } = useContext(KYBCompanyContext);

    const handleSubmit = (e, values) => {
        setCompanyData((currentState) => {
            return { ...currentState, ...values }
        });

        onNextButtonClicked();
    }

    return (
        <AvForm
            className="needs-validation m-2"
            onValidSubmit={handleSubmit}
        >
            <Row>
                <Col sm='12'>
                    <Card>
                        <CardHeader className="bg-white">
                            <h5 className="mb-1">
                                {t('Confirm Search Details')}
                            </h5>
                            <p className="text-muted mb-0">
                                {t('Review and confirm the details that will be used to query external data providers. Providing accurate information, such as the registration number, country, or other available identifiers, helps ensure accurate and reliable results. You may update these details before proceeding.')}
                            </p>
                        </CardHeader>
                        <CardBody>

                            <Row>
                                <Col sm='12'>
                                    <Card>
                                        <CardBody className="d-flex align-items-center justify-content-between">
                                            <div className="w-100">
                                                <Label>
                                                    {supplierData?.type === 'individual' ? (
                                                        <>
                                                            {t('Name')}: <span className="text-danger">*</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {t('Company Name')}: <span className="text-danger">*</span>
                                                        </>
                                                    )}
                                                </Label>
                                                <AvField
                                                    type="text"
                                                    name="name"
                                                    value={companyData.name || ''}
                                                    readOnly={true}
                                                    validate={{
                                                        required: {
                                                            value: true,
                                                            errorMessage: t('Company Name is required')
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <Button
                                                    color="primary"
                                                    outline
                                                    type="button"
                                                    className="border-0"
                                                    onClick={() => {
                                                        console.log('ok')
                                                    }}
                                                >
                                                    <RiPencilLine size="24" />
                                                </Button>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col sm='12'>
                                    <Card>
                                        <CardBody className="d-flex align-items-center justify-content-between">
                                            <div className="w-100">
                                                {supplierData?.type === 'individual' ? (
                                                    <Label>
                                                        {t('Nickname / AKA')}:
                                                    </Label>
                                                ) : (
                                                    <Label>
                                                        {t('Short Name')}:
                                                    </Label>
                                                )}

                                                <AvField
                                                    type="text"
                                                    name="shortName"
                                                    value={companyData.shortName || ''}
                                                    readOnly={true}
                                                />
                                            </div>
                                            <div>
                                                <Button
                                                    color="primary"
                                                    outline
                                                    type="button"
                                                    className="border-0"
                                                    onClick={() => {
                                                        console.log('ok')
                                                    }}
                                                >
                                                    <RiPencilLine size="24" />
                                                </Button>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col sm='12'>
                                    <Card>
                                        <CardBody className="d-flex align-items-center justify-content-between">
                                            <div className="w-100">
                                                <Label>
                                                    {t('Registeration Number')}:
                                                </Label>
                                                <AvField
                                                    type="text"
                                                    name="registerationNumber"
                                                    value={companyData.registrationNumber || ''}
                                                    readOnly={true}
                                                />
                                            </div>
                                            <div>
                                                <Button
                                                    color="primary"
                                                    outline
                                                    type="button"
                                                    className="border-0"
                                                    onClick={() => {
                                                        console.log('ok')
                                                    }}
                                                >
                                                    <RiPencilLine size="24" />
                                                </Button>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col sm='12'>
                                    <Card>
                                        <CardBody className="d-flex align-items-center justify-content-between">
                                            <div className="w-100">
                                                <Label>
                                                    {t('Country')}: <span className="text-danger">*</span>
                                                </Label>
                                                <AvField
                                                    type="text"
                                                    name="country"
                                                    value={companyData.country || ''}
                                                    readOnly={true}
                                                />
                                            </div>
                                            <div>
                                                <Button
                                                    color="primary"
                                                    outline
                                                    type="button"
                                                    className="border-0"
                                                    onClick={() => {
                                                        console.log('ok')
                                                    }}
                                                >
                                                    <RiPencilLine size="24" />
                                                </Button>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>

                <Col sm='12' className="d-flex justify-content-between">
                    <Button
                        color="secondary"
                        type="button"
                        outline
                        onClick={onCancelButtonClicked}
                    >
                        {t('Cancel')}
                    </Button>

                    <div>
                        <Button
                            color="primary"
                            type="submit"
                        >
                            {t('Next')}
                        </Button>
                    </div>
                </Col>
            </Row>
        </AvForm>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        user: state.Login.user,
        token: token
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {}
    )(ConfirmSearchItem)
)